import React, { useCallback, useEffect, useState } from "react";
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";
import Form from 'react-bootstrap/Form';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { FormattedMessage, injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { ElementsConsumer } from "@stripe/react-stripe-js";

import CurrencyConverter from "../../../CurrencyConverter/CurrencyConverter";
import CardForm from "../../../CardForm/CardForm";
import CommonModal from "../../../Modal/CommonModal";
import SelectFieldComponent from "../../../Common/SelectFieldComponent/SelectFieldComponent";

import { closeHeaderModal } from '../../../../actions/siteadmin/modalActions';

import messages from "../../../../locale/messages";
import submit from "./submit";

import useQueryResponse from "../../../../lib/hooks/useQueryResponse";
import getPaymentMethodsQuery from './getAllPaymentMethods.graphql';

import cardEditIcon from '/public/dashboard/cardEditIcon.svg';
import creditDebitIcon from '/public/dashboard/creditDebitIcon.svg';
import dropdownTickIcon from '/public/Icons/dropdownTickIcon.svg';
import { LinkPlusIcon } from "../../../Common/Assets/SVGIcon/CommonSvgIcon";
import cashIcon from '../../../../../public/Icons/cash.png';
import cardIcon from '../../../../../public/Icons/cards.png';
import walletIcon from '../../../../../public/Icons/wallet.png';
import paypalIcon from '../../../../../public/Icons/paypal.png';
import history from "../../../../history";

import bt from '../../../commonStyle.css';
import s from './PaymentMethod.css';


function PaymentMethod(props) {

    const {
        initialValues,
        userPaymentMethod,
        isTopRadius,
        intl: { formatMessage },
        id,
        handleSubmit,
        isPaymentCompleted,
        orderId,
        isaddPayment
    } = props

    const dispatch = useDispatch()
    const selector = formValueSelector('PaymentMethod');
    const paymentMethodId = useSelector(state => selector(state, 'paymentMethodId'))
    const currency = useSelector(state => state?.userAccount?.data?.preferredCurrency)
    const siteName = useSelector(state => state?.siteSettings?.data?.siteName)
    const currencyList = useSelector(state => state?.currency?.availableCurrencies)


    const { data: paymentMethods, loading } = useQueryResponse({
        query: getPaymentMethodsQuery,
        ssr: true,
        fetchPolicy: 'network-only'
    })

    const [selectedPayment, setSelectedPayment] = useState(String(initialValues.paymentMethodId || ''));

    useEffect(() => {
        setSelectedPayment(String(initialValues.paymentMethodId || ''));
    }, [initialValues.paymentMethodId]);

    let walletAmount = userPaymentMethod?.getPaymentMethod?.result?.walletBalance;
    let userCardPaymentMethodId = userPaymentMethod?.getPaymentMethod?.result?.paymentMethodId;

    const handleSelectPayment = useCallback(
        async (eventKey) => {
            setSelectedPayment(String(eventKey));
            await dispatch(change('PaymentMethod', 'paymentMethodId', eventKey));
            await dispatch(change('PaymentMethod', 'walletAmount', walletAmount));
            await dispatch(change('PaymentMethod', 'userCardPaymentMethodId', userCardPaymentMethodId));
            await dispatch(change('PaymentMethod', 'bookingId', id))
            id && await handleSubmit(submit)()
        });


    const renderNavDropdownField = ({ input, meta: { touched, error }, fieldClass, placeholder, children }) => {

        let title = placeholder;
        if (input.value) {
            const displayValues = {
                '1': <span className={s.paymentMethodList}><img src={cashIcon} alt="cashIcon" />{formatMessage(messages.cash)}</span>,
                '2': <span className={s.paymentMethodList}><img src={cardIcon} alt="cardIcon" />{formatMessage(messages.creditDebitLabel)}</span>,
                '3': (
                    <span className={s.paymentMethodList}>
                        <img src={walletIcon} alt="walletIcon" />
                        {
                            !isPaymentCompleted ? (<>
                                {formatMessage(messages.walletText)}
                                <CurrencyConverter from={currency} amount={walletAmount} />
                            </>) : formatMessage(messages.walletTextLabel)
                        }
                    </span>

                ),
                '4': formatMessage(messages.googlePayText),
                '5': <span className={s.paymentMethodList}><img src={paypalIcon} alt="paypalIcon" />{formatMessage(messages.paypalLabel)}</span>
            };
            title = displayValues[input.value] || placeholder;
            dispatch(change('PaymentMethod', 'paymentMethodId', input.value));
            dispatch(change('PaymentMethod', 'walletAmount', walletAmount));
            dispatch(change('PaymentMethod', 'userCardPaymentMethodId', userCardPaymentMethodId));
        }

        return (
            <>
                <label className={cx(bt.commonSize16, bt.fontWeight700, bt.space1, bt.primaryColor)}>{placeholder}</label>
                <NavDropdown
                    title={title}
                    className={fieldClass}
                    onSelect={(eventKey) => {
                        input.onChange(eventKey);
                        handleSelectPayment(eventKey);
                    }}
                >
                    {children}
                </NavDropdown>
                {touched && error && <span>{formatMessage(error)}</span>}
            </>
        );
    };

    const handleClickPaymentMethod = (form) => {
        if (isaddPayment) {
            form === "creditDebitForm" ? history.push(`/add-card?tracking=${id}`) : history.push(`/add-wallet?tracking=${id}`)
        } else {
            form === "creditDebitForm" ? history.push(`/add-card?type=${orderId}`) : history.push(`/add-wallet?type=${orderId}`)
        }

    }

    const renderCardDetails = () => {
        const lastFourDigits = userPaymentMethod?.getPaymentMethod?.result?.cardLastFour;

        return (
            <>
                <div className={cx(s.cardNumberShow, 'svgImg')}>
                    <span className={cx(bt.commonSize14, bt.fontWeight600, bt.primaryColor, bt.textAlignStart, s.creditCardInnerWrapper)}>
                        <img src={creditDebitIcon} alt="creditDebitIcon" />
                        <span>
                            <span className={bt.displayInlineBlock}>**** **** ****&nbsp;</span>
                            <span className={bt.displayInlineBlock}>{lastFourDigits}</span>
                        </span>
                    </span>
                    <img src={cardEditIcon} alt="Edit" onClick={() => handleClickPaymentMethod("creditDebitForm")} className={bt.cursorPointer} />
                </div>
                <div className={cx(bt.commonSize14, bt.fontWeight400, bt.secondaryColor, bt.textAlignStart)}>
                    <FormattedMessage {...messages.cardLabel} /> {siteName}.
                </div>
            </>
        );
    }

    const enabledPaymentMethods = paymentMethods?.getAllPaymentMethods?.results && paymentMethods.getAllPaymentMethods.results.filter(method => method.isEnable)

    let userPaymentMethodId = userPaymentMethod?.getPaymentMethod?.result?.paymentMethodId

    let rows = [{ value: '', label: formatMessage(messages.chooseCurrency) }];

    if (currencyList != null && currencyList?.length > 0) {
        currencyList?.map((item, index) => {
            if (item?.isEnable && item?.isPayment) {
                rows.push({
                    value: item?.symbol,
                    label: item?.symbol
                }
                );
            }
        });
    }
    return (
        <div className={cx(bt.commonViewBookingRsBox, isTopRadius ? s.paymentMethodBoxTopRadius : s.paymentMethodBoxBottomRadius)}>
            <Form>
                <Form.Group className={bt.space0}>
                    <Field
                        name="paymentMethodId"
                        placeholder={!isPaymentCompleted ? formatMessage(messages.paymentMethodText) : formatMessage(messages.paidText)}
                        component={renderNavDropdownField}
                        fieldClass={cx("paymentDropdownContainer", isPaymentCompleted && "paymentDropdownContainerReadonly")}
                    >
                        {
                            !isPaymentCompleted && enabledPaymentMethods
                                ?.filter(item => item.paymentType !== 4)
                                ?.map(item => (
                                    <NavDropdown.Item key={item.id} eventKey={item.paymentType}>
                                        <div className={cx(s.paymentDropdownItemsFlex)}>
                                            {item.paymentType === 1 &&
                                                <span className={s.paymentMethodList}>
                                                    <img src={cashIcon} alt="cashIcon" />{formatMessage(messages.cash)}
                                                </span>}
                                            {item.paymentType === 2 &&
                                                <span className={s.paymentMethodList}>
                                                    <img src={cardIcon} alt="cardIcon" />{formatMessage(messages.creditDebitLabel)}
                                                </span>}
                                            {item.paymentType === 3 && (
                                                <span className={s.paymentMethodList}>
                                                    <img src={walletIcon} alt="walletIcon" />
                                                    <span>{formatMessage(messages.walletText)}</span>
                                                    <CurrencyConverter from={currency} amount={walletAmount} />
                                                </span>
                                            )}
                                            {item.paymentType === 5 &&
                                                <span className={s.paymentMethodList}>
                                                    <img src={paypalIcon} alt="paypalIcon" />{formatMessage(messages.paypalLabel)}
                                                </span>}
                                            {selectedPayment === String(item.paymentType) &&
                                                <span className={cx("svgImg", s.dropdownTickIcon)}><img src={dropdownTickIcon} alt="dropdownTickIcon" /></span>}
                                        </div>
                                    </NavDropdown.Item>
                                ))
                        }
                    </Field>

                </Form.Group>
            </Form>
            {!isPaymentCompleted && paymentMethodId == 3 && (<div className={bt.spaceTop2}><div onClick={() => handleClickPaymentMethod("walletForm")} className={bt.customLink}>
                <LinkPlusIcon />
                <FormattedMessage {...messages.addWallet} />
            </div></div>)}
            {!isPaymentCompleted && paymentMethodId == 2 && ((userPaymentMethodId != null && userPaymentMethodId != 0) ? renderCardDetails()
                : <div className={bt.spaceTop2}><div onClick={() => handleClickPaymentMethod("creditDebitForm")} className={bt.customLink}>
                    <LinkPlusIcon />
                    <FormattedMessage {...messages.addCard} />
                </div></div>)}
            {!isPaymentCompleted && selectedPayment === '5' &&
                <Field
                    name="paypalCurrency"
                    component={SelectFieldComponent}
                    options={rows}
                    label={formatMessage(messages.currency)}
                    formGroupClass={bt.spaceTop2}
                    inputClass={bt.formControlSelect}
                    labelClass={bt.fontWeight700}
                />
            }
        </div>
    )

}

PaymentMethod = reduxForm({
    form: 'PaymentMethod',
    enableReinitialize: true,
    onSubmit: submit
})(PaymentMethod)

export default injectIntl(withStyles(bt, s)(PaymentMethod));
